import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useMe } from "@/api/hooks";
import { Layout } from "@/components/Layout";
import { PageSkeleton } from "@/components/ui/skeleton";
import { ErrorState } from "@/components/States";
import RecentPage from "@/pages/Recent";
import SpacePage from "@/pages/Space";
import NotePage from "@/pages/Note";
import NoteEditPage from "@/pages/NoteEdit";
import NoteNewPage from "@/pages/NoteNew";
import ThreadsPage from "@/pages/Threads";
import ThreadPage from "@/pages/Thread";
import SearchPage from "@/pages/Search";
import TokensPage from "@/pages/SettingsTokens";
import ConnectPage from "@/pages/SettingsConnect";
import SharedNotePage from "@/pages/Shared";
import OAuthConsentPage from "@/pages/OAuthConsent";
import SignInPage from "@/pages/SignIn";
import AccountPage from "@/pages/SettingsAccount";
import NotFoundPage from "@/pages/NotFound";

function Authenticated() {
  const me = useMe();
  const location = useLocation();
  if (me.isLoading) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-10">
        <PageSkeleton />
      </div>
    );
  }
  if (me.isError) {
    return (
      <div className="mx-auto max-w-md px-4 py-10">
        <ErrorState error={me.error} retry={() => me.refetch()} title="Could not reach the API" />
      </div>
    );
  }
  if (!me.data) return <SignInPage returnTo={location.pathname + location.search} />;
  return <Layout />;
}

export default function App() {
  return (
    <Routes>
      {/* Public / standalone */}
      <Route path="/s/:token" element={<SharedNotePage />} />
      <Route path="/oauth/consent/:id" element={<OAuthConsentPage />} />
      {/* The API bounces here (with ?returnTo= and ?error=) when a session is needed. */}
      <Route path="/login" element={<SignInPage />} />
      <Route path="/signin" element={<Navigate to="/login" replace />} />

      {/* App shell */}
      <Route element={<Authenticated />}>
        <Route path="/" element={<RecentPage />} />
        <Route path="/spaces/:id" element={<SpacePage />} />
        <Route path="/spaces/:id/new" element={<NoteNewPage />} />
        <Route path="/notes/:id" element={<NotePage />} />
        <Route path="/notes/:id/edit" element={<NoteEditPage />} />
        <Route path="/threads" element={<ThreadsPage />} />
        <Route path="/threads/:id" element={<ThreadPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/settings" element={<Navigate to="/settings/account" replace />} />
        <Route path="/settings/account" element={<AccountPage />} />
        <Route path="/settings/tokens" element={<TokensPage />} />
        <Route path="/settings/connect" element={<ConnectPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
